<obg-m-dialog-layout
	test-id="dialog-layout-modal"
	#dialog
	[titleText]="'limits-reminder.title'"
	[hideFooter]="true"
	[hideClose]="true"
>
	<obg-m-limits-reminder
		[limitsModalType]="limitsModalType$ | async"
		[limitsSummary]="limitsSummary$ | async"
		[balance]="balance$ | async"
		(closeEvent)="closeDialog()"
		(redirectToResponsibleGamingEvent)="redirectToResponsibleGaming()"
	>
	</obg-m-limits-reminder>
</obg-m-dialog-layout>
